<template>
  <div class="elenco-buoni-scarico" v-loading="loading">

    <transition name="fade">
      <ricerca v-show="showRicercaPanel" @closeRicerca="closeSearch" @ricerca="ricerca" @changeCountry="changeCountry"></ricerca>
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-4 no-padding icon-search">
        <el-button @click="openSearch">
          <icon name="riv-filter" scale="1.4"></icon>
        </el-button>
      </div>
      <div class="label-left col-16 no-padding">
        {{ $t('elencoBuoni.elencoBuoni').toUpperCase() + ' ' + conf.numConf  + ((form.stab.descStab !== '') ? (' - ' + form.stab.descStab) : '') }}
      </div>
    </div>
    <div class="riepilogo-viaggi col-24">
      <el-button class="custom-button" @click="openRiepilogoViaggi">
        {{$t('elencoBuoni.riepilogoViaggi').toUpperCase()}}
      </el-button>
    </div>

    <el-table :data="buoniDiScarico" class="col-24 no-padding custom-table" @row-click="selectBuono"  @sort-change="sortChange">

      <el-table-column width="15">
        <template>
          <div class="name-wrapper">
            {{ ' ' }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="numBuono"
        :label="$t('elencoBuoni.numBuono')"
        min-width="80">
      </el-table-column>

      <el-table-column
        prop="datBuono" sortable="custom"
        :label="$t('elencoBuoni.dataBuono')"
        min-width="90">
      </el-table-column>

      <el-table-column
        prop="datArrivo" sortable="custom"
        :label="$t('elencoBuoni.dataArrivo')"
        min-width="90">
      </el-table-column>

      <el-table-column
        prop="tarMotri"
        :label="$t('elencoBuoni.targaMotrice')"
        min-width="90">
      </el-table-column>

      <el-table-column
        :label="$t('elencoBuoni.spedizioniere')"
        min-width="135">

        <template slot-scope="scope">
          <div class="name-wrapper">
            <span>{{scope.row.nomTrasp | formatString}}</span>
          </div>
        </template>

      </el-table-column>

      <el-table-column
        prop="catRotta"
        :label="$t('elencoBuoni.categoria')"
        min-width="45">
      </el-table-column>

      <el-table-column
        prop="qtaBuono"
        :label="$t('elencoBuoni.qta')"
        min-width="100">
      </el-table-column>

      <el-table-column
        prop="desStato"
        :label="$t('elencoBuoni.statoBuono')"
        min-width="100">
      </el-table-column>

      <el-table-column
        width="40">
        <template slot-scope="scope">
          <div class="name-wrapper pdf" v-if="scope.row.ifPRT === 'Y'">
            <el-tooltip class="item" effect="dark" :content="($t('elencoBuoni.download'))" placement="top">
              <icon name="riv-pdf_RGB" scale="1.5" @click.native.stop="downloadDoc(scope.row)" />
            </el-tooltip>
          </div>
          <div class="name-wrapper pdf" v-else>
            <el-tooltip class="item" effect="dark" :content="scope.row.ifPRT" placement="top">
              <icon name="riv-pdf_BW" scale="1.5" @click.native.stop="" />
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        width="40">
        <template slot-scope="scope">
          <div class="name-wrapper icon actions" v-if="scope.row.ifPRT === 'Y'">
            <el-tooltip class="item" effect="dark" :content="($t('elencoBuoni.inviaMail'))" placement="top">
              <icon name="riv-envelopeClosed" scale="1" @click.native.stop="openMailModal(scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

      <el-table-column
        width="40">
        <template slot-scope="scope">
          <div class="name-wrapper icon actions">
            <el-tooltip class="item" effect="dark" :content="($t('elencoBuoni.cancella'))" placement="top">
              <icon name="riv-delete2" scale="1" @click.native.stop="openCancDialog(scope.row)"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>

    </el-table>

    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage"
                   background class="custom-pagination"
                   layout="prev, pager, next"
                   :total="nrItems"
                   :page-size="pag_for"
                   @current-change="changePage">
    </el-pagination>

    <el-dialog :append-to-body="true" class="modalRiepilogoViaggi"
               :title="$t('elencoBuoni.titoloTutteCat').toUpperCase()"
               custom-class="custom-dialog offset-xl-7 col-xl-10 offset-lg-5 col-lg-14 offset-md-4 col-md-16 offset-1 col-22" :visible.sync="riepilogoViaggiVisible">

      <el-table :data="viaggi" @expand-change="goToDettaglioViaggio" class="custom-table">

        <el-table-column prop="dataViaggio" :label="$t('elencoBuoni.data')" min-width="100" align="center"
                         header-align="center">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <span>{{ moment(scope.row.dataViaggio, 'DD MM YYYY').format('DD/MM/YYYY') }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="viaggiPrevisti" :label="$t('elencoBuoni.viaggiPrevisti')" min-width="100"
                         align="center" header-align="center">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <span>{{parseInt(scope.row.viaggiPrevisti)}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="viaggiPrenotati" :label="$t('elencoBuoni.viaggiPrenotati')" min-width="100"
                         align="center" header-align="center">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <span>{{parseInt(scope.row.viaggiPrenotati)}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="viaggiMancanti" :label="$t('elencoBuoni.viaggiMancanti')" min-width="100"
                         align="center" header-align="center">
          <template slot-scope="scope">
            <div class="name-wrapper">
              <span>{{parseInt(scope.row.viaggiMancanti)}}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column type="expand">
          <template class="exp" slot-scope="props">
            <el-table :data="viaggiDettaglio" v-loading="loadingDettaglio" :key="props.row.dataViaggio">
              <el-table-column prop="desProd" :label="$t('elencoBuoni.tipo')" min-width="100" align="center"
                               header-align="center">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    <span>{{scope.row.desProd}}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="viaggiPrevisti" :label="$t('elencoBuoni.viaggiPrevisti')" min-width="100"
                               align="center" header-align="center">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    <span>{{parseInt(scope.row.viaggiPrevisti)}}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="viaggiPrenotati" :label="$t('elencoBuoni.viaggiPrenotati')" min-width="100"
                               align="center" header-align="center">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    <span>{{parseInt(scope.row.viaggiPrenotati)}}</span>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="viaggiMancanti" :label="$t('elencoBuoni.viaggiMancanti')" min-width="100"
                               align="center" header-align="center">
                <template slot-scope="scope">
                  <div class="name-wrapper">
                    <span>{{parseInt(scope.row.viaggiMancanti)}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>

          </template>
        </el-table-column>

      </el-table>

    </el-dialog>

    <el-dialog :append-to-body="true" :title="$t('elencoBuoni.titoloCanc').toUpperCase()"
               custom-class="custom-dialog offset-8 col-8" :visible.sync="cancDialogVisible">

      <span class="label-cancella col-24 no-padding">
        {{ $t('elencoBuoni.cancellareBuono') }} {{ buonoToDelete.numBuono + '?' }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button class="custom-button" @click="cancDialogVisible = false">
          {{ $t('elencoBuoni.annulla').toUpperCase() }}
        </el-button>
        <el-button class="custom-button" type="primary" @click="cancellaBuono">{{ $t('elencoBuoni.cancella').toUpperCase() }}</el-button>
      </span>
    </el-dialog>

    <el-dialog :append-to-body="true" class="modal-mail"
               :title="$t('elencoBuoni.titoloMail').toUpperCase()"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-6 col-lg-12 offset-md-4 col-md-16
                             offset-sm-2 col-sm-20 offset-1 col-22"
               :visible.sync="mailModalVisible"
    >

      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.from') }}
        </div>
        <div class="col-16 no-padding mail-value">
          <el-input v-model="buonoToSend.from" :maxlength="70" class="custom-input"></el-input>
        </div>
      </div>
      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.to') }}
        </div>
        <div class="col-14 no-padding mail-value">
          <!--
          <el-input v-model="buonoToSend.to" :maxlength="70"></el-input>
          -->
          <el-select class="custom-select-el"
            v-model="buonoToSend.to"
            filterable allow-create default-first-option clearable
            placeholder="">
            <el-option
              v-for="item in mailingList"
              :key="item.mail"
              :label="item.desc"
              :value="item.mail">
            </el-option>
          </el-select>
        </div>
        <div class="col-2 no-padding icone-mail">
          <el-tooltip class="item" effect="dark" :content="($t('elencoBuoni.aggiungiCancella'))" placement="top">
            <icon name="riv-prenotazione" class="pointer col-12 no-padding" scale="1" @click.native="openModificaMail"></icon>
          </el-tooltip>
        </div>
      </div>
      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.subject') }}
        </div>
        <div class="col-16 no-padding mail-value">
          <el-input v-model="buonoToSend.subject" :maxlength="70" class="custom-input"></el-input>
        </div>
      </div>
      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.text') }}
        </div>
        <div class="col-16 no-padding mail-value">
          <el-input type="textarea" v-model="buonoToSend.text" class="custom-input"
                    :autosize="{ minRows: 6, maxRows: 8 }"
                    :maxlength="250"
                    resize="none"
          >
          </el-input>
        </div>
      </div>
      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.allegato') }}
        </div>
        <div class="col-18 no-padding mail-value">
          {{ $t('elencoBuoni.buonoDiScarico')  + ' ' + buonoToSend.numBuono }}
        </div>
      </div>
      <div slot="footer">
        <div class="bottoni">
          <el-button class="custom-button" :loading="loadingMail" @click="(mailModalVisible = false)">
            {{ $t('elencoBuoni.annulla').toUpperCase() }}
          </el-button>
          <el-button class="custom-button" type="primary" @click="inviaMail" :loading="loadingMail">
            {{ $t('elencoBuoni.invia').toUpperCase() }}
          </el-button>
        </div>
      </div>

    </el-dialog>

    <el-dialog :append-to-body="true" class="modal-mail rubrica"
               :title="$t('elencoBuoni.aggiungiCancella').toUpperCase()"
               custom-class="custom-dialog offset-xl-8 col-xl-8 offset-lg-6 col-lg-12 offset-md-4 col-md-16
                             offset-sm-2 col-sm-20 offset-1 col-22"
               :visible.sync="newMailVisible"
    >

      <el-table :data="mailingList" v-loading="loadingMail" class="custom-table"
                style="width: 100%">
        <el-table-column
          prop="mail"
          :label="($t('elencoBuoni.mail'))"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="desc"
          :label="($t('elencoBuoni.nome'))"
          min-width="180">
        </el-table-column>
        <el-table-column
          prop="address"
          width="30">

          <template slot-scope="scope">
            <div class="name-wrapper">
              <icon name="riv-delete2" class="pointer" scale="1" @click.native="modificaMail('DEL', scope.row)"></icon>
            </div>
          </template>

        </el-table-column>
      </el-table>

      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.mail') }}
        </div>
        <div class="col-15 no-padding mail-value">
          <el-input v-model="newMail.mail" :maxlength="70" class="custom-input"></el-input>
        </div>
      </div>
      <div class="row row-custom riga">
        <div class="col-6 mail-label">
          {{ $t('elencoBuoni.nome') }}
        </div>
        <div class="col-15 no-padding mail-value">
          <el-input v-model="newMail.desc" :maxlength="70" class="custom-input"></el-input>
        </div>
      </div>
      <div slot="footer">
        <div class="bottoni">
          <el-button @click="modificaMail('ADD')" :loading="loadingMail" class="custom-button" type="primary">
            {{ $t('elencoBuoni.aggiungi').toUpperCase() }}
          </el-button>
        </div>
      </div>

    </el-dialog>

  </div>

</template>

<script>
  import {bus} from '../../Bus'
  import Ricerca from './Ricerca.vue'
  import moment from 'moment'

  export default {
    name: 'ElencoBuoni',
    components: {Ricerca},
    filters: {
      formatString: function (string) {
        if (string === '') {
          return ' '
        }
        return string
      }
    },
    i18n: {
      messages: {
        it_IT: {
          elencoBuoni: {
            riepilogoViaggi: 'Riepilogo viaggi',
            numBuono: 'Nr. Buono',
            dataBuono: 'Data buono',
            dataArrivo: 'Data arrivo',
            targaMotrice: 'Targa motrice',
            spedizioniere: 'Spedizioniere',
            categoria: 'Categ.',
            qta: 'Quantità (Kg)',
            statoBuono: 'Stato',
            indietro: 'Indietro',
            nuovo: 'Nuovo',
            titoloTutteCat: 'Viaggi per tutte le categorie',
            data: 'Data',
            viaggiPrevisti: 'Viaggi previsti',
            viaggiPrenotati: 'Viaggi prenotati',
            viaggiMancanti: 'Viaggi mancanti',
            titoloSingolaCat: 'Dettaglio viaggi per la categoria',
            tipo: 'Tipo',
            titoloCanc: 'Cancellazione buono',
            cancellareBuono: 'Cancellare definitivamente il buono',
            annulla: 'Annulla',
            cancella: 'Cancella',
            elencoBuoni: 'Elenco buoni',
            download: 'Download',
            from: 'Mittente',
            to: 'Destinatario',
            subject: 'Oggetto',
            text: 'Testo',
            allegato: 'Allegato',
            buonoDiScarico: 'Buono di Scarico',
            titoloMail: 'Invia buono di scarico',
            invia: 'Invia',
            inviaMail: 'Invia per mail',
            invioRiuscito: 'Mail inviata correttamente',
            invioFallito: 'Errore nell\'invio mail',
            erroreFormatoMail: 'Formato mail non valido',
            aggiungiCancella: 'Rubrica',
            mail: 'Mail',
            nome: 'Nome',
            aggiungi: 'Aggiungi',
            erroreNomeMail: 'Nome mail obbligatorio'
          }
        },
        fr_FR: {
          elencoBuoni: {
            riepilogoViaggi: 'Réservations disponibles',
            numBuono: 'Nr.bon',
            dataBuono: 'Date bon de décharg.',
            dataArrivo: 'Date arrivée',
            targaMotrice: 'Imm. tracteur',
            spedizioniere: 'Transporteur',
            categoria: 'Catég.',
            qta: 'Quantité (Kg)',
            statoBuono: 'Statut',
            indietro: 'Retour en arrière',
            nuovo: 'Nouveau bon',
            titoloTutteCat: 'Voyages pour toutes les categories',
            data: 'Date',
            viaggiPrevisti: 'Exp. prévues',
            viaggiPrenotati: 'Exp. réservées',
            viaggiMancanti: 'Exp. manquantes',
            titoloSingolaCat: 'Détail des voyages par catégorie',
            tipo: 'Type',
            scegli: 'Choisir...',
            filtri: 'Filtres',
            titoloCanc: 'Bon annulation',
            cancellareBuono: 'Supprimer définitivement le bon',
            annulla: 'Annuler',
            cancella: 'Supprimer',
            elencoBuoni: 'Liste bons décharg.',
            download: 'Download',
            from: 'Expéditeur',
            to: 'Destinataire',
            subject: 'Sujet',
            text: 'Texte',
            allegato: 'Enceinte',
            buonoDiScarico: 'Bon de Déchargement',
            titoloMail: 'Envoyer le Bon de Déchargement',
            invia: 'Envoyer',
            inviaMail: 'Envoyer par mail',
            invioRiuscito: 'Mail envoyé correctement',
            invioFallito: 'Erreur d\'envoi du mail',
            erroreFormatoMail: 'Format mail invalide',
            aggiungiCancella: 'Carnet d\'Adresses',
            mail: 'Mail',
            nome: 'Prenom',
            aggiungi: 'Ajouter',
            erroreNomeMail: 'Nom email obligatoire'
          }
        },
        es_ES: {
          elencoBuoni: {
            riepilogoViaggi: 'Resumen de viaje',
            numBuono: 'Nr.vale',
            dataBuono: 'Fecha vale de descarga',
            dataArrivo: 'Dìa llegada',
            targaMotrice: 'Matr.cabeza',
            spedizioniere: 'Transpostista',
            categoria: 'Categ.',
            qta: 'Cantidad (Kg)',
            statoBuono: 'Estado',
            indietro: 'Atràs',
            nuovo: 'Nuevo',
            titoloTutteCat: 'Viajes para todas las categorias',
            data: 'Dìa',
            viaggiPrevisti: 'Viajes previsto',
            viaggiPrenotati: 'Viajes reservados',
            viaggiMancanti: 'Viajes que faltan',
            titoloSingolaCat: 'Detalle de los viajes por categoría',
            tipo: 'Tipo',
            scegli: 'Elegir...',
            filtri: 'Filtros',
            titoloCanc: 'Vale cancelación',
            cancellareBuono: 'Eliminar permanentemente el vale',
            annulla: 'Atrás',
            cancella: 'Eliminar',
            elencoBuoni: 'Lista vales de descarga',
            download: 'Download',
            from: 'Remitente',
            to: 'Beneficiario',
            subject: 'Asunto',
            text: 'Texto',
            allegato: 'Anexo',
            buonoDiScarico: 'Vale de descarga',
            titoloMail: 'Enviar vale de descarga',
            invia: 'Enviar',
            inviaMail: 'Enviar por Correo',
            invioRiuscito: 'Correo enviado correctamente',
            invioFallito: 'Error al enviar el correo',
            erroreFormatoMail: 'Formato de correo no válido',
            aggiungiCancella: 'Libreta de Direcciones',
            mail: 'Mail',
            nome: 'Nombre',
            aggiungi: 'Añadir',
            erroreNomeMail: 'Nombre de email obligatorio'
          }
        },
        de_DE: {
          elencoBuoni: {
            riepilogoViaggi: 'Transportübersicht',
            numBuono: 'Nr.Schein',
            dataBuono: 'Datum Entladeschein',
            dataArrivo: 'Ankunfts',
            targaMotrice: 'Kennzeichen',
            spedizioniere: 'Spediteur',
            categoria: 'Kateg.',
            qta: 'Menge (kg)',
            statoBuono: 'Status',
            indietro: 'Zurück',
            nuovo: 'Neuen',
            titoloTutteCat: 'Trasporte für alle sorten',
            data: 'Datum',
            viaggiPrevisti: 'Geplante transporte',
            viaggiPrenotati: 'Gebuchte transporte',
            viaggiMancanti: 'Fehlende transporte',
            titoloSingolaCat: 'Trasporte Nach Sorte',
            tipo: 'Typ',
            scegli: 'Wählen...',
            filtri: 'Filter',
            titoloCanc: 'Schein Stornierung',
            cancellareBuono: 'Dauerhaftes Löschen Entladeschein',
            annulla: 'Zurück',
            cancella: 'Löschen',
            elencoBuoni: 'Übersicht Entladescheine',
            download: 'Download',
            from: 'Absender',
            to: 'Empfänger',
            subject: 'Betreff',
            text: 'Text',
            allegato: 'Anhang',
            buonoDiScarico: 'Entladeschein',
            titoloMail: 'Entladeschein versenden',
            invia: 'Versenden',
            inviaMail: 'Per E-Mail senden',
            invioRiuscito: 'Mail erfolgreich gesendet',
            invioFallito: 'Fehler beim Senden der Mail',
            erroreFormatoMail: 'Ungültiges Mail-Format',
            aggiungiCancella: 'Adressbuch',
            mail: 'Mail',
            nome: 'Name',
            aggiungi: 'Hinzufügen',
            erroreNomeMail: 'Obligatorischer E-Mail-Name'
          }
        },
        en_GB: {
          elencoBuoni: {
            riepilogoViaggi: 'Travel list',
            numBuono: 'Nr.Pass',
            dataBuono: 'Pass date',
            dataArrivo: 'Arrival date',
            targaMotrice: 'Driving plate',
            spedizioniere: 'Forwarder',
            categoria: 'Categ.',
            qta: 'Quantity (Kg)',
            statoBuono: 'State',
            indietro: 'Back',
            nuovo: 'New',
            titoloTutteCat: 'Travel for all categories',
            data: 'Date',
            viaggiPrevisti: 'Planned travels',
            viaggiPrenotati: 'Booked travels',
            viaggiMancanti: 'Missing travels',
            titoloSingolaCat: 'Detail Of Travel By Category',
            tipo: 'Type',
            scegli: 'Choose...',
            filtri: 'Filters',
            titoloCanc: 'Pass cancellation',
            cancellareBuono: 'Permanently delete the pass',
            annulla: 'Back',
            cancella: 'Delete',
            elencoBuoni: 'Pass list',
            download: 'Download',
            from: 'Sender',
            to: 'Recipient',
            subject: 'Subject',
            text: 'Text',
            allegato: 'Attachment',
            buonoDiScarico: 'Discharge voucher',
            titoloMail: 'Send discharge voucher',
            invia: 'Send',
            inviaMail: 'Send by mail',
            invioRiuscito: 'Mail sent successfully',
            invioFallito: 'Error sending mail',
            erroreFormatoMail: 'Invalid mail format',
            aggiungiCancella: 'Address Book',
            mail: 'Mail',
            nome: 'Name',
            aggiungi: 'Add',
            erroreNomeMail: 'Obligatory email name'
          }
        }
      }
    },
    data () {
      return {
        moment: moment,
        loadingDettaglio: false,
        codLang: sessionStorage.getItem('codLang'),
        buoniDiScarico: [],
        form: {
          country: '',
          stab: {
            codSoc: '',
            codStab: ''
          },
          fornitore: {
            codForn: '',
            tipForn: ''
          },
          ifTSL: {
            value: '',
            desc: ''
          }
        },
        conf: {
          numConf: ''
        },
        buono: {},
        pag_for: 11,
        nrItems: 0,
        nrPages: 0,
        currentPage: 1,
        riepilogoViaggiVisible: false,
        dettaglioViaggioVisible: false,
        viaggi: [{
          dataViaggio: ''
        }],
        viaggiDettaglio: [],
        cancDialogVisible: false,
        buonoToDelete: {},
        loading: true,
        showRicercaPanel: false,
        mailModalVisible: false,
        buonoToSend: {
          from: '',
          to: '',
          subject: '',
          text: '',
          numBuono: '',
          codStab: '',
          codSoc: '',
          numConf: ''
        },
        loadingMail: false,
        newMailVisible: false,
        mailingList: [],
        newMail: {
          mail: '',
          desc: ''
        },
        buonoSelected: {},
        codForn: '',
        ordine: '2D'
      }
    },
    mounted: function () {
      bus.$on('WebGestioneRottame-RicercaBuono', () => {
        this.$set(this, 'loading', true)
        if (sessionStorage.hasOwnProperty('WGR_conf')) {
          this.$set(this, 'conf', JSON.parse(sessionStorage.getItem('WGR_conf')))
        }
        this.$set(this, 'form', JSON.parse(sessionStorage.getItem('WGR_form')))
        this.getBuoniDiScarico(1)
      })
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.getBuoniDiScarico(1)
      })
      bus.$on('Header_SetCodFornAdmin', () => {
        this.$set(this, 'buoniDiScarico', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
      bus.$on('TRAACQ_ChangeCountryFromDsh', () => {
        this.$set(this, 'buoniDiScarico', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      })
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    methods: {
      downloadDoc: function (buono) {
        this.$http.get('portale/tokendoc')
          .then(response => {
            if (response.body.wsToken) {
              let url = (process.env.baseUrlSpringRottame + 'download/buonodiscarico?' +
                  'codLang=' + this.codLang +
                  '&country=' + this.form.country +
                  '&numBuono=' + buono.numBuono +
                  '&codSoc=' + this.form.stab.codSoc + '&codStab=' + this.form.stab.codStab +
                  '&numConf=' + (this.conf ? this.conf.numConf : '') +
                  '&codForn=' + (this.form.fornitore.codForn ? this.form.fornitore.codForn : '') +
                  '&tipoForn=' + (this.form.fornitore.tipForn ? this.form.fornitore.tipForn : '') +
                  '&token=' + response.body.wsToken)
              let win = window.open(url, '_blank')
              win.focus()
            } else {
              this.$message({
                showClose: true,
                message: 'Error creating token',
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      sortChange: function ({column, prop, order}) {
        if (prop === 'datBuono') {
          if (order === 'ascending') {
            this.ordine = '2A'
          } else if (order === 'descending') {
            this.ordine = '2D'
          }
        } else if (prop === 'datArrivo') {
          if (order === 'ascending') {
            this.ordine = '4A'
          } else if (order === 'descending') {
            this.ordine = '4D'
          }
        }
        this.getBuoniDiScarico(true)
      },
      openModificaMail: function () {
        let newMail = {
          mail: '',
          desc: ''
        }
        this.$set(this, 'newMail', newMail)
        this.$set(this, 'newMailVisible', true)
      },
      validateEmail: function (email) {
        let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email.toLowerCase())
      },
      modificaMail: function (op, mail) {
        if (op === 'ADD') {
          if (this.validateEmail(this.newMail.mail) && (this.newMail.desc !== '')) {
            this.$set(this, 'loadingMail', true)
            let data = {
              codLang: this.codLang,
              country: this.form.country,
              codForn: this.form.fornitore.codForn,
              tipoForn: this.form.fornitore.tipForn,
              op: op,
              mail: this.newMail.mail,
              desc: this.newMail.desc
            }
            this.$http.post('buonidiscarico/mailinglist', data)
              .then(response => {
                if (response.body.rc === 0) {
                  this.$set(this, 'newMailVisible', false)
                  /*
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'success',
                    duration: process.env.duration
                  })
                  */
                  this.getMailingList(this.newMail.mail)
                } else {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                }
                this.$set(this, 'loadingMail', false)
              })
          } else {
            if (!this.validateEmail(this.newMail.mail)) {
              this.$message({
                showClose: true,
                message: this.$t('elencoBuoni.erroreFormatoMail'),
                type: 'error',
                duration: process.env.duration
              })
            } else {
              this.$message({
                showClose: true,
                message: this.$t('elencoBuoni.erroreNomeMail'),
                type: 'error',
                duration: process.env.duration
              })
            }
          }
        } else {
          this.$set(this, 'loadingMail', true)
          let data = {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn,
            op: op,
            mail: mail.mail,
            desc: mail.desc
          }
          this.$http.post('buonidiscarico/mailinglist', data)
            .then(response => {
              if (response.body.rc === 0) {
                /*
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'success',
                  duration: process.env.duration
                })
                */
                this.getMailingList()
              } else {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
                this.$set(this, 'loadingMail', false)
              }
            })
        }
      },
      inviaMail: function () {
        if (this.validateEmail(this.buonoToSend.from) && this.validateEmail(this.buonoToSend.to)) {
          this.$set(this, 'loadingMail', true)
          let data = {...this.buonoToSend}
          data.codLang = this.codLang
          data.country = this.form.country
          data.codForn = this.form.fornitore.codForn
          data.tipoForn = this.form.fornitore.tipForn
          this.$http.post('buonidiscarico/mail', data)
            .then(response => {
              if (response.body.rc === 0) {
                this.$set(this, 'mailModalVisible', false)
                this.$message({
                  showClose: true,
                  message: this.$t('elencoBuoni.invioRiuscito'),
                  type: 'success',
                  duration: process.env.duration
                })
              } else {
                this.$message({
                  showClose: true,
                  message: this.$t('elencoBuoni.invioFallito'),
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this, 'loadingMail', false)
            })
        } else {
          this.$message({
            showClose: true,
            message: this.$t('elencoBuoni.erroreFormatoMail'),
            type: 'error',
            duration: process.env.duration
          })
        }
      },
      openMailModal: function (buono) {
        this.$set(this, 'buonoSelected', buono)
        this.getMailingList()
      },
      getMailingList: function (to) {
        this.$set(this, 'loadingMail', false)
        this.$http.get('buonidiscarico/mailinglist', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codForn: this.form.fornitore.codForn,
            tipoForn: this.form.fornitore.tipForn
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'mailingList', response.body.data)
              let buonoToSent = {
                from: sessionStorage.getItem('mailFornitore'),
                to: (to !== undefined) ? to : '',
                subject: this.$t('elencoBuoni.buonoDiScarico') + ' - ' + this.buonoSelected.numBuono,
                text: '',
                numBuono: this.buonoSelected.numBuono,
                codStab: this.form.stab.codStab,
                codSoc: this.form.stab.codSoc,
                numConf: this.conf.numConf
              }
              this.$set(this, 'buonoToSend', buonoToSent)
              this.$set(this, 'mailModalVisible', true)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            this.$set(this, 'loadingMail', false)
          })
      },
      resetDati: function () {
        this.$set(this, 'buoniDiScarico', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
        let form = {
          country: '',
          stab: {
            codSoc: '',
            codStab: ''
          },
          fornitore: {
            codForn: '',
            tipForn: ''
          },
          ifTSL: {
            value: '',
            desc: ''
          }
        }
        this.$set(this, 'form', form)
        let conf = {
          numConf: ''
        }
        this.$set(this, 'conf', conf)
        this.$set(this, 'buono', {})
        this.$set(this, 'mailModalVisible', false)
        let buonoToSend = {
          from: '',
          to: '',
          subject: '',
          text: '',
          numBuono: '',
          codStab: '',
          codSoc: '',
          numConf: ''
        }
        this.$set(this, 'buonoToSend', buonoToSend)
        this.$set(this, 'newMailVisible', false)
        this.$set(this, 'mailingList', [])
        let newMail = {
          mail: '',
          desc: ''
        }
        this.$set(this, 'newMail', newMail)
        this.$set(this, 'buonoSelected', {})
        this.$set(this, 'ordine', '2D')
      },
      init: function () {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        if (sessionStorage.hasOwnProperty('WGR_form')) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('WGR_form')))
          if (sessionStorage.hasOwnProperty('WGR_conf')) {
            this.$set(this, 'conf', JSON.parse(sessionStorage.getItem('WGR_conf')))
          }
          this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
          this.getBuoniDiScarico(1)
        } else {
          this.$router.push('/rottame/gestionerottame/conferme')
        }
      },
      changeCountry: function () {
        this.$set(this, 'buoniDiScarico', [])
        this.$set(this, 'nrPages', 0)
        this.$set(this, 'nrItems', 0)
        this.$set(this, 'currentPage', 1)
      },
      openSearch: function () {
        this.showRicercaPanel = true
        this.$emit('hideScroll')
      },
      closeSearch: function () {
        this.showRicercaPanel = false
        this.$emit('showScroll')
      },
      ricerca: function (form) {
        this.loading = true
        this.$set(this, 'form', JSON.parse(form))
        this.$set(this, 'codForn', this.form.fornitore.tipForn + this.form.fornitore.codForn)
        if (!this._inactive) {
          this.getBuoniDiScarico(1)
        }
      },
      cancellaBuono: function () {
        let data = {
          codLang: this.codLang,
          country: this.form.country,
          codForn: this.codForn.substring(1),
          tipoForn: this.codForn.substring(0, 1),
          codSoc: this.form.stab.codSoc,
          codStab: this.form.stab.codStab,
          numConf: (this.conf !== null) ? this.conf.numConf : '',
          numBuono: this.buonoToDelete.numBuono,
          mail: sessionStorage.getItem('mailFornitore')
        }
        this.$http.delete('buonidiscarico/buono', {
          body: data
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$message({
                message: response.body.msg[0].msgTxt,
                type: 'success'
              })
              this.cancDialogVisible = false
              this.getBuoniDiScarico(1)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      openCancDialog: function (buono) {
        this.cancDialogVisible = true
        this.buonoToDelete = buono
      },
      back: function () {
        this.$router.push({name: 'GestioneRottameConferme'})
        this.$nextTick(() => {
          bus.$emit('WebGestioneRottame-Ricerca')
        })
      },
      goToDettaglioViaggio: function (row, expanded) {
        this.$set(this, 'loadingDettaglio', true)
        this.$set(this, 'viaggiDettaglio', [])
        let ifOpen = false
        expanded.forEach((viaggio, index) => {
          if (viaggio.dataViaggio === row.dataViaggio) {
            ifOpen = true
            expanded.splice(0, expanded.length)
            expanded.push(row)
          }
        })
        if (ifOpen === true) {
          setTimeout(() => {
            this.getDettaglioViaggio(row.dataViaggio)
          }, 300)
        } else {
          this.$set(this, 'loadingDettaglio', false)
        }
      },
      openRiepilogoViaggi: function () {
        this.getListViaggi()
      },
      selectBuono: function (row, event, column) {
        sessionStorage.setItem('WGR_buono', JSON.stringify(row))
        this.$router.push({name: 'GestioneRottameDettaglio'})
      },
      changePage: function (page) {
        this.$set(this, 'currentPage', page)
        this.getBuoniDiScarico(page)
      },
      getBuoniDiScarico: function (flagIfChangeSort) {
        this.loading = true
        if (flagIfChangeSort === true) {
          this.$set(this, 'form', JSON.parse(sessionStorage.getItem('WGR_form')))
          this.$set(this, 'currentPage', 1)
        }
        if (this.form.buonoDiScarico !== '') {
          this.$set(this, 'currentPage', 1)
        }
        this.$http.get('buonidiscarico/buoni', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            modoTrasp: (this.form.buonoDiScarico === '') ? this.conf.modoTrasp : '', // sempre vuoto se passo il numero di buono
            action: (this.currentPage === 1) ? 'BEGIN' : 'NEXT',
            numBuono: this.form.buonoDiScarico.toUpperCase(),
            pag_for: this.pag_for,
            codStab: this.form.stab.codStab,
            pag_from: this.currentPage - 1,
            numConf: (this.form.buonoDiScarico === '') ? this.conf.numConf : '',
            idOrdin: this.ordine,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1),
            codSoc: this.form.stab.codSoc,
            ifTSL: this.form.ifTSL.value
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'buoniDiScarico', response.body.data)
              if (this.currentPage === 1) {
                this.$set(this, 'nrPages', 0)
                this.$set(this, 'nrItems', 0)
                let nrItems = parseInt(response.body.attrib.size)
                let nrPages = parseInt(response.body.attrib.size / this.pag_for)
                nrPages = (nrItems % this.pag_for > 0) ? (nrPages + 1) : nrPages
                this.$set(this, 'nrPages', nrPages)
                this.$set(this, 'nrItems', nrItems)
              }
            } else {
              this.$set(this, 'nrPages', 0)
              this.$set(this, 'nrItems', 0)
              this.$set(this, 'buoniDiScarico', [])
              if (response.body.msg[0].msgId !== '1001') {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
            }
            this.loading = false
          })
      },
      getListViaggi: function () {
        this.$http.get('buonidiscarico/viaggi', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codStab: this.form.stab.codStab,
            numConf: this.conf.numConf,
            codSoc: this.form.stab.codSoc,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.viaggi = response.body.data
              this.riepilogoViaggiVisible = true
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getDettaglioViaggio: function (dataViaggio) {
        this.$http.get('buonidiscarico/viaggi/dettaglio', {
          params: {
            codLang: this.codLang,
            country: this.form.country,
            codStab: this.form.stab.codStab,
            numConf: this.conf.numConf,
            codSoc: this.form.stab.codSoc,
            dataViaggio: dataViaggio,
            codForn: this.codForn.substring(1),
            tipoForn: this.codForn.substring(0, 1)
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this, 'viaggiDettaglio', response.body.data)
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
            setTimeout(() => {
              this.$set(this, 'loadingDettaglio', false)
            }, 1000)
          })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  @import "../../../assets/less/general.less";

  .rubrica {
    .el-dialog__header {
      border-bottom: 0;
    }
  }

  .modal-mail {
    .el-dialog {
      .el-dialog__body {
        .el-table {
          max-height: 290px;
          overflow: auto;
          margin-bottom: 60px;
        }
        .riga {
          margin-bottom: 10px;
          .mail-label {
            .set-font(@size: 11px, @color: @greenRiva, @family: 'os-semibold');
            text-align: right;
            line-height: 22px;
            overflow: hidden;
            text-overflow: ellipsis;
            text-transform: uppercase;
            letter-spacing: 1px;
          }
          .icone-mail {
            text-align: right;
            line-height: 18px;
          }
          .mail-value {
            .custom-select-el {
              .el-input__inner {
                height: 22px !important;
                border: 1px solid #dcdfe6;
                padding: 0 5px;
              }
            }
            .custom-input {
              .el-input__inner {
                height: 22px !important;
                padding: 0 5px;
                border: 1px solid #dcdfe6;
              }
            }
          }
        }
      }
    }
  }

  .modalRiepilogoViaggi {
    .el-dialog {
      .el-dialog__header {
        border-bottom: 0;
      }
      .el-dialog__body {
        .el-table {
          td {
            &.el-table__expanded-cell {
              padding: 10px 10px 35px 70px;
              .el-table {
                .el-table__header-wrapper {
                  .el-table__header {
                    border-bottom: 1px solid #ccc;
                    th {
                      .cell {
                        .set-font(@family: 'os-lightitalic', @size: 12px);
                      }
                    }
                  }
                }
                .el-table__body {
                  td {
                    padding: 3px 0;
                    .cell {
                      .set-font(@family: 'os-regular', @size: 11px, @color: @textTable);
                      line-height: 20px !important;
                    }
                  }
                }
              }
            }
            &.el-table__expanded-cell:hover {
              background-color: @white;
            }
          }
        }
      }
    }
  }

  .elenco-buoni-scarico {
    .header-tab {
      height: 65px;
      text-align: center;
      .label-left {
        line-height: 55px;
        height: 45px;
        .set-font(@color: @oroRiva; @size: 22px; @family: 'os-semibolditalic');
        letter-spacing: 2px;
      }
      .icon-search {
        line-height: 65px;
        .el-button {
          height: 40px;
          width: 40px;
          border-radius: 0;
          margin: 12px 0 0 10px;
          padding: 0;
          color: @greenRiva;
          float: left;
          border: 1px solid @greenRiva;
        }
        .el-button:hover {
          background-color: @white;
        }
      }
    }
    .riepilogo-viaggi {
      text-align: right;
      margin-bottom: 10px;
    }
    .el-table {
      height: 420px;
      td {
        .cell {
          .pdf {
            width: 100%;
            text-align: center;
          }
          .icon {
            text-align: center;
          }
        }
      }
      tbody {
        tr:hover {
          cursor: pointer;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Rottame/WebGestioneRottame/ElencoBuoni.vue